// @flow

import { RedirectServices, getRedirectUrl } from 'config/paths';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { Licenses } from 'types/common';

import advertissementImage from '../../../assets/images/avertissement.png';
import dswvImage from '../../../assets/images/de/dswv.png';
import gglImage from '../../../assets/images/de/ggl.png';
import under18EsImage from '../../../assets/images/es/18.png';
import autoProhibitionImage from '../../../assets/images/es/autoprohibition.png';
import juegoSeguroImage from '../../../assets/images/es/jugarsegurokk.png';
import under18Image from '../../../assets/images/under18.png';
import config from '../../../config/app.config';
import { getLang } from '../../../i18n/l10n';
import { __ } from '../../../i18n/l10n';
import { media } from '../../../styles/GlobalStyle';

// FR

// ES

import { JuegoConResponsabilidad, NoHayJuego } from './common';

// DE
import { ForbiddenLogo, ResponsiblyLogo } from './FooterSpritesheet';

const Disclaimer = styled.div`
  display: none;

  ${media.greaterThan('desktop')`
    display: flex;
    height: 60px;
    background: #000;
    justify-content: space-between;
  `}
`;

const Forbidden = styled.div`
  display: none;

  ${media.greaterThan('desktop')`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 10px;
  `}
`;

const ForbiddenText = styled.div`
  margin: 0 20px;
`;

const Img = styled.img`
  max-height: 40px;
  max-width: 100%;

  ${media.greaterThan('desktop')`
    max-height: 100%;
  `}
`;

const PaddedContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ${media.greaterThan('desktop')`
    width: fit-content;
    height: 100%;
    padding: 0.6em 2em;
  `}
`;

const Link = styled.a``;

const MargedLogo = styled.div`
  margin-right: 1em;
`;

const InlineLogoText = styled.div`
  display: flex;
  align-items: center;
  margin: 0 3em;

  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'auto')};
`;

const ImageSizeDE = styled.img`
  height: 34px;
`;

type HeaderByLicensesProps = {
  className?: string,
};

const HeaderByLicenses = ({ className }: HeaderByLicensesProps) => {
  const redirectToResponsibleGaming = useCallback(() => {
    window.location.href = getRedirectUrl(RedirectServices.RESPONSIBLE_GAMING);
  }, []);

  switch (config.license) {
    case Licenses.ES:
      return (
        <>
          <Disclaimer className={className}>
            <PaddedContainer>
              <JuegoConResponsabilidad />
            </PaddedContainer>
            <PaddedContainer>
              <NoHayJuego />
            </PaddedContainer>
            <Link href={'/respecto-a-winamax_proteccion-de-los-jugadores_juego-responsable'}>
              <PaddedContainer>
                <Img src={under18EsImage} />
              </PaddedContainer>
            </Link>
            <Link
              href={'http://www.ordenacionjuego.es/es/rgiaj'}
              target={'_blank'}
              rel={'noopener noreferrer'}
            >
              <Img src={autoProhibitionImage} />
            </Link>
            <Link
              href={'https://www.ordenacionjuego.es/participantes-juego/juego-seguro'}
              target={'_blank'}
              rel={'noopener noreferrer'}
            >
              <PaddedContainer>
                <Img src={juegoSeguroImage} />
              </PaddedContainer>
            </Link>
          </Disclaimer>
        </>
      );
    case Licenses.DE:
      return (
        <>
          <Disclaimer className={className}>
            <InlineLogoText onClick={redirectToResponsibleGaming}>
              <MargedLogo as={ResponsiblyLogo} />
              {__('Responsible gaming')}
            </InlineLogoText>
            <InlineLogoText>
              <MargedLogo as={ForbiddenLogo} />
              {__('No minors')}
            </InlineLogoText>
            <InlineLogoText>
              <ImageSizeDE src={dswvImage} />
            </InlineLogoText>
            <InlineLogoText>
              <ImageSizeDE src={gglImage} />
            </InlineLogoText>
          </Disclaimer>
        </>
      );
    case Licenses.FR:
    default:
      return (
        <>
          {getLang() === 'fr' && (
            <Disclaimer className={className}>
              <Img
                src={advertissementImage}
                alt={'Jouer comporte des risques'}
              />
              <Forbidden>
                <Img
                  src={under18Image}
                  alt={__('No minors')}
                />
                <ForbiddenText>{__('Gambling is prohibited for minors')}</ForbiddenText>
              </Forbidden>
            </Disclaimer>
          )}
        </>
      );
  }
};

export default HeaderByLicenses;
